import { render } from "./HomeLGPD.vue?vue&type=template&id=0235be59&scoped=true"
import script from "./HomeLGPD.vue?vue&type=script&lang=js"
export * from "./HomeLGPD.vue?vue&type=script&lang=js"

import "./HomeLGPD.vue?vue&type=style&index=0&id=0235be59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0235be59"]])

export default __exports__